import Grid from '@material-ui/core/Grid';
import styled from 'styled-components';

const StyledElementMargin = styled(Grid)`
  && {
    &:empty {
      display: none;
    }
  }
`;
export default StyledElementMargin;
